import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { ClientVersionService } from '../client-version/client-version.service';
import { MessageLogs } from './messageLogs.interfaces';
import { Message } from './messages.interfaces';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);
  private readonly clientVersionService = inject(ClientVersionService);

  // pagination
  perPage = 6;
  currentPage = 1;
  offset: number | null = null;
  fetch: number | null = null;

  getAllMessages(): Observable<Message[]> {
    const clientVersion = this.clientVersionService.getVersion();
    const url = `${this.globals.apiRoot}/jwtmessages?clientVersion=${clientVersion}&isApp=true`;
    return this.http.get<Message[]>(url);
  }

  /**
   * get dashboard log messages
   */
  getDashboardLogMessages(currentPage: number): Observable<MessageLogs[]> {
    this.offset = (currentPage - 1) * this.perPage;
    this.fetch = this.offset + this.perPage;

    const url =
      `${this.globals.apiRoot}/JwtAdminDashboard/logs?offset=` +
      this.offset +
      `&fetch=` +
      this.fetch;
    return this.http.get<MessageLogs[]>(url);
  }

  /**
   * Get number of unread messages
   */
  getNumberOfUnreadMessages(): Observable<number> {
    const clientVersion = this.clientVersionService.getVersion();
    const url = `${this.globals.apiRoot}/jwtmessages/count?clientVersion=${clientVersion}&isApp=true`;
    return this.http.get<number>(url);
  }

  /**
   * Get the important messages to show as popup
   */
  getImportantMessages(): Observable<Message[]> {
    const clientVersion = this.clientVersionService.getVersion();
    const url = `${this.globals.apiRoot}/jwtmessages/important?clientVersion=${clientVersion}&isApp=true`;
    return this.http.get<Message[]>(url);
  }

  /**
   * Update important message, set read to true
   */
  updateImportantMessage(id: number): Observable<void> {
    const url = `${this.globals.apiRoot}/jwtmessages/important/${id}`;
    return this.http.put<void>(url, id);
  }

  /**
   * Update message, set read to true
   */
  updateMessage(id: number): Observable<void> {
    const url = `${this.globals.apiRoot}/jwtmessages/${id}`;
    return this.http.put<void>(url, id);
  }
}
